<template>
  <div class="compnents-wrap_live_duration">
    <el-tooltip
      popper-class="live-room-tooltip"
      class="duration"
      effect="dark"
      :content="'课时时长 ' + lessonDuration"
      placement="top-start"
    >
      <div class="live-duration_wrap">
        <span class="live-duration">{{ liveDuration }}</span>
        <span class="lesson-duration">（{{ lessonDuration }}）</span>
        <span class="delay-tips" v-if="isDelay">已拖堂</span>
      </div>
    </el-tooltip>
    <div
      class="lesson-end-tips"
      :class="{
        'screen-share': ['start', 'pause'].includes(screenShareStatus),
      }"
      v-if="!isCloseLiveDurationTips && isShowDelayTips && !roomInfo.isStudent"
    >
      课程已结束，教室将在
      <span>{{ formatSeconds(delayDuration, { showHours: false }) }}</span>
      {{ label }} 后关闭
      <img
        src="@saas/pages/assets/images/live/close-1.png"
        alt=""
        @click="onClickCloseTips"
      />
    </div>
    <live-end ref="liveEnd"></live-end>
  </div>
</template>

<script>
import LiveEnd from "../dialog/LiveEnd.vue";
import { mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import { playMediaSafely } from "@saas/components/src/utils/media-play";
export default {
  components: {
    LiveEnd,
  },
  data() {
    return {
      liveTimer: null,
      liveDuration: 0,
      // 是否显示拖堂提示
      isShowDelayTips: false,
      // 结束倒计时
      endTimer: null,
      // 是否已经拖堂
      isDelay: false,
      // 最多拖堂时长
      // maxDelayDuration: 20 * 60,
      // 还剩拖堂时长
      delayDuration: 30 * 60,
    };
  },
  computed: {
    ...mapState("live", [
      "cameraList",
      "liveService",
      "microphoneList",
      "speakerList",
      "layout",
      "roomInfo",
      "whiteBoardService",
      "isCloseLiveDurationTips",
      "screenShareStatus",
      "lessonId",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
    label() {
      return this.delayDuration < 60 ? "秒" : "分钟";
    },
    // 最多拖堂时长
    maxDelayDuration() {
      return this.roomInfo.end_delay_time;
    },
    lessonDuration() {
      if (this.roomInfo.live_end_time && this.roomInfo.room_start_time) {
        const dealy = this.isDelay ? this.maxDelayDuration : 0;
        const duration =
          this.roomInfo.live_end_time - this.roomInfo.room_start_time + dealy;
        // 秒转成 1小时1分钟 的格式
        return this.formatSeconds(duration, {
          showSeconds: false,
          textFormat: true,
        });
      } else {
        return "-";
      }
    },
  },
  watch: {
    "roomInfo.room_start_time": {
      handler(val) {
        if (val) {
          let initDuration = parseInt(Date.now() / 1000) - val;
          this.liveDuration = this.formatSeconds(initDuration);
          clearInterval(this.liveTimer);
          this.liveTimer = setInterval(() => {
            initDuration += 1;
            this.liveDuration = this.formatSeconds(initDuration);
            this.checkLessonEnd();
          }, 1000);
        } else {
          clearInterval(this.liveTimer);
        }
      },
      immediate: true,
    },
    isDelay: {
      handler(val, oldVal) {
        // 只有当值从 false 变为 true，且刚刚超过下课时间（3秒内）才播放
        // 这样可以避免刷新页面、共享切换时重复播放
        if (val && oldVal === false) {
          const now = parseInt(Date.now() / 1000);
          const timeSinceEnd = now - this.roomInfo.live_end_time;
          // 只有刚超过下课时间 3 秒内才播放铃声
          if (timeSinceEnd <= 3 && !this.roomInfo.isStudent) {
            void playMediaSafely(this.$endClassBell);
          }
        }
      },
    },
  },
  methods: {
    ...mapMutations("live", [
      "setLayout",
      "setOnlineCount",
      "setIsDelay",
      "setIsCloseLiveDurationTips",
    ]),
    checkLessonEnd() {
      const now = parseInt(Date.now() / 1000);
      if (this.roomInfo.live_end_time < now) {
        if (!this.isDelay) {
          this.isDelay = true;
          this.setIsDelay(true);
          this.delayDuration =
            this.maxDelayDuration - (now - this.roomInfo.live_end_time);
          if (this.delayDuration > 0) {
            this.isShowDelayTips = true;
          } else {
            this.isShowDelayTips = false;
            clearInterval(this.endTimer);
            clearInterval(this.liveTimer);
            this.liveService.exitRoom();
            this.$refs.liveEnd.open();
            if (window.isElectron) {
              window.ipcRenderer.send("end-class", {
                lessonId: this.lessonId,
                courseId: this.roomInfo.course_id,
              });
            } else {
              void playMediaSafely(this.$endClassBell);
            }
            return;
          }
          clearInterval(this.endTimer);
          this.endTimer = setInterval(() => {
            if (this.delayDuration < 1) {
              clearInterval(this.endTimer);
              clearInterval(this.liveTimer);
              this.isShowDelayTips = false;
              this.liveService.exitRoom();
              this.$refs.liveEnd.open();
              if (window.isElectron) {
                window.ipcRenderer.send("end-class", {
                  lessonId: this.lessonId,
                  courseId: this.roomInfo.course_id,
                });
              } else {
                void playMediaSafely(this.$endClassBell);
              }
              return;
            }
            this.delayDuration = this.delayDuration - 1;
          }, 1000);
        }
      }
    },
    // 关闭课程结束提示
    onClickCloseTips() {
      uploadLiveLog({
        message: "用户点击课程结束提示关闭按钮",
        extra: {
          component: "LiveDuration",
          action: "click_close_delay_tips",
          isDelay: this.isDelay,
          delayDuration: this.delayDuration,
        },
      });

      this.isShowDelayTips = false;
      this.setIsCloseLiveDurationTips(true);
    },
    formatSeconds(seconds, options = {}) {
      if (seconds < 0) {
        seconds = 0;
      }
      const {
        showSeconds = true, // 是否显示秒
        showMinutes = true,
        showHours = true,
        separator = ":", // 数字分隔符（仅当 showSeconds 为 true 时有效）
        textFormat = false, // 是否使用文本格式（如 "小时"、"分钟"、"秒"）
      } = options;

      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;

      if (textFormat) {
        let result = "";
        if (showHours) {
          result += `${h}小时`;
        }
        if (showMinutes) {
          result += `${m}分钟`;
        }
        if (showSeconds) {
          result += `${s}秒`;
        }
        return result || "0秒"; // 若全为0，返回0秒
      } else {
        const parts = [];
        if (showHours) {
          parts.push(h);
        }
        if (showMinutes) {
          parts.push(m);
        }
        if (showSeconds) {
          parts.push(s);
        }
        return parts
          .map((num) => num.toString().padStart(2, "0"))
          .join(separator);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.duration {
  font-weight: 500;
  font-size: 12px;
  color: #c9cdd4;
  text-align: left;
  .live-duration {
    display: inline-block;
    width: 50px;
  }
  .delay-tips {
    color: #f53f3f;
  }
}
.lesson-end-tips {
  position: fixed;
  top: 50px;
  left: 50%;
  z-index: 9999;
  transform: translateX(-50%);
  width: 326px;
  height: 40px;
  background: #27272a;
  border-radius: 8px 8px 8px 8px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 14px;
  color: #ecedee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 35px;
    color: #ff7d00;
  }
  img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.screen-share {
  top: 100px;
}
</style>
